export const collapsedReducer = (prevState={isCollapsed:true}, action) => {
    const {type} = action

    switch(type){
        case 'change_collapsed':
            let newState = {...prevState}
            newState.isCollapsed = !newState.isCollapsed
            return newState
        default:
            return prevState
    }
}
